import React from 'react';
import FAQContent from './Components';

const FAQPage: React.FC = () => {
  return <FAQContent />;
};

export default FAQPage;
